<template>
	<a :href="`https://booking.eu.guestline.app/DELPHI/availability?hotel=DELPHI&lng=${locale}`" target="_blank">
		<slot />
	</a>
</template>

<script setup>
const { locale } = useI18n();

defineProps({
	language: { type: String, default: '' },
	arrival: { type: String, default: '' },
	departure: { type: String, default: '' },
	pax: { type: String, default: '' },
	packageid: { type: String, default: '' },
	roomid: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
